import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Logo } from "@/components/Logo";

export function AuthCompletePage() {
  const { signInWithToken } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const hash = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(hash);
    const token = params.get("token");
    const redirect = params.get("redirect") ?? "/";

    window.history.replaceState(null, "", window.location.pathname);

    if (!token) {
      setError("Missing token from sign-in callback.");
      return;
    }
    void signInWithToken(token)
      .then(() => navigate(redirect, { replace: true }))
      .catch(() => setError("Sign-in failed. Please try again."));
  }, [navigate, signInWithToken]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4">
      <Logo />
      {error ? (
        <div className="text-center">
          <p className="text-sm text-red-600 dark:text-red-300">{error}</p>
          <button
            type="button"
            onClick={() => navigate("/login", { replace: true })}
            className="mt-3 text-sm text-brand-600 hover:text-brand-700 dark:text-brand-300 dark:hover:text-brand-200"
          >
            Back to sign in
          </button>
        </div>
      ) : (
        <p className="text-sm text-zinc-600 dark:text-zinc-400">Signing you in…</p>
      )}
    </div>
  );
}
